import { Signal } from "./Signal.js";

export class Slot<T extends any[] = any[]> {
    public once: boolean = false;
    public enabled: boolean = true;

    constructor(
        public readonly signal: Signal<T>,
        public listener: (...args: T) => any,
        public context: any,
        public namespace: string) {
    }

    public execute(target: Signal<T>, args: any[]): void {
        this.listener.apply(this.context, args as any);
    }

    public remove(): void {
        console.warn("Slot.remove() is deprecated. Use Slot.dispose() instead.");
        this.dispose();
    }

    public dispose(): void {
        if (this.signal) {
            var s = this.signal;
            (this as Mutable<Slot<T>>).signal = null;
            s.remove(this.listener, this.context);
        }
        this.context = null;
        this.namespace = null;
        this.listener = null;
    }
}